// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { Position, PositionT } from '../tbs/position.js';


export class MoveUnitAction implements flatbuffers.IUnpackableObject<MoveUnitActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MoveUnitAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMoveUnitAction(bb:flatbuffers.ByteBuffer, obj?:MoveUnitAction):MoveUnitAction {
  return (obj || new MoveUnitAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMoveUnitAction(bb:flatbuffers.ByteBuffer, obj?:MoveUnitAction):MoveUnitAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MoveUnitAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameMoveUnit;
}

unitId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

targetId():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

pickupId():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

startPosition(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

destPosition(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

destHeading():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

attackPosition(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

annex():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

wait():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

taxiId():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

cargoId():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

unloadPosition(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

mergeId():number {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startMoveUnitAction(builder:flatbuffers.Builder) {
  builder.startObject(14);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameMoveUnit);
}

static addUnitId(builder:flatbuffers.Builder, unitId:number) {
  builder.addFieldInt32(1, unitId, 0);
}

static addTargetId(builder:flatbuffers.Builder, targetId:number) {
  builder.addFieldInt32(2, targetId, -1);
}

static addPickupId(builder:flatbuffers.Builder, pickupId:number) {
  builder.addFieldInt32(3, pickupId, -1);
}

static addStartPosition(builder:flatbuffers.Builder, startPositionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, startPositionOffset, 0);
}

static addDestPosition(builder:flatbuffers.Builder, destPositionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, destPositionOffset, 0);
}

static addDestHeading(builder:flatbuffers.Builder, destHeading:number) {
  builder.addFieldInt32(6, destHeading, -1);
}

static addAttackPosition(builder:flatbuffers.Builder, attackPositionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, attackPositionOffset, 0);
}

static addAnnex(builder:flatbuffers.Builder, annex:boolean) {
  builder.addFieldInt8(8, +annex, +false);
}

static addWait(builder:flatbuffers.Builder, wait:boolean) {
  builder.addFieldInt8(9, +wait, +false);
}

static addTaxiId(builder:flatbuffers.Builder, taxiId:number) {
  builder.addFieldInt32(10, taxiId, -1);
}

static addCargoId(builder:flatbuffers.Builder, cargoId:number) {
  builder.addFieldInt32(11, cargoId, -1);
}

static addUnloadPosition(builder:flatbuffers.Builder, unloadPositionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(12, unloadPositionOffset, 0);
}

static addMergeId(builder:flatbuffers.Builder, mergeId:number) {
  builder.addFieldInt32(13, mergeId, -1);
}

static endMoveUnitAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): MoveUnitActionT {
  return new MoveUnitActionT(
    this.type(),
    this.unitId(),
    this.targetId(),
    this.pickupId(),
    (this.startPosition() !== null ? this.startPosition()!.unpack() : null),
    (this.destPosition() !== null ? this.destPosition()!.unpack() : null),
    this.destHeading(),
    (this.attackPosition() !== null ? this.attackPosition()!.unpack() : null),
    this.annex(),
    this.wait(),
    this.taxiId(),
    this.cargoId(),
    (this.unloadPosition() !== null ? this.unloadPosition()!.unpack() : null),
    this.mergeId()
  );
}


unpackTo(_o: MoveUnitActionT): void {
  _o.type = this.type();
  _o.unitId = this.unitId();
  _o.targetId = this.targetId();
  _o.pickupId = this.pickupId();
  _o.startPosition = (this.startPosition() !== null ? this.startPosition()!.unpack() : null);
  _o.destPosition = (this.destPosition() !== null ? this.destPosition()!.unpack() : null);
  _o.destHeading = this.destHeading();
  _o.attackPosition = (this.attackPosition() !== null ? this.attackPosition()!.unpack() : null);
  _o.annex = this.annex();
  _o.wait = this.wait();
  _o.taxiId = this.taxiId();
  _o.cargoId = this.cargoId();
  _o.unloadPosition = (this.unloadPosition() !== null ? this.unloadPosition()!.unpack() : null);
  _o.mergeId = this.mergeId();
}
}

export class MoveUnitActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameMoveUnit,
  public unitId: number = 0,
  public targetId: number = -1,
  public pickupId: number = -1,
  public startPosition: PositionT|null = null,
  public destPosition: PositionT|null = null,
  public destHeading: number = -1,
  public attackPosition: PositionT|null = null,
  public annex: boolean = false,
  public wait: boolean = false,
  public taxiId: number = -1,
  public cargoId: number = -1,
  public unloadPosition: PositionT|null = null,
  public mergeId: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const startPosition = (this.startPosition !== null ? this.startPosition!.pack(builder) : 0);
  const destPosition = (this.destPosition !== null ? this.destPosition!.pack(builder) : 0);
  const attackPosition = (this.attackPosition !== null ? this.attackPosition!.pack(builder) : 0);
  const unloadPosition = (this.unloadPosition !== null ? this.unloadPosition!.pack(builder) : 0);

  MoveUnitAction.startMoveUnitAction(builder);
  MoveUnitAction.addType(builder, this.type);
  MoveUnitAction.addUnitId(builder, this.unitId);
  MoveUnitAction.addTargetId(builder, this.targetId);
  MoveUnitAction.addPickupId(builder, this.pickupId);
  MoveUnitAction.addStartPosition(builder, startPosition);
  MoveUnitAction.addDestPosition(builder, destPosition);
  MoveUnitAction.addDestHeading(builder, this.destHeading);
  MoveUnitAction.addAttackPosition(builder, attackPosition);
  MoveUnitAction.addAnnex(builder, this.annex);
  MoveUnitAction.addWait(builder, this.wait);
  MoveUnitAction.addTaxiId(builder, this.taxiId);
  MoveUnitAction.addCargoId(builder, this.cargoId);
  MoveUnitAction.addUnloadPosition(builder, unloadPosition);
  MoveUnitAction.addMergeId(builder, this.mergeId);

  return MoveUnitAction.endMoveUnitAction(builder);
}
}
